<!-- prettier-ignore -->

<button class="chat__button chat__button--stop" type="button">
  <icon-stop />
</button>
